import { render, staticRenderFns } from "./NewLogo.vue?vue&type=template&id=0dca23cc"
import script from "./NewLogo.vue?vue&type=script&lang=ts"
export * from "./NewLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dca23cc')) {
      api.createRecord('0dca23cc', component.options)
    } else {
      api.reload('0dca23cc', component.options)
    }
    module.hot.accept("./NewLogo.vue?vue&type=template&id=0dca23cc", function () {
      api.rerender('0dca23cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/logo/NewLogo.vue"
export default component.exports